
















import { defineComponent, ref } from '@nuxtjs/composition-api'

import BlockTopMessage from '@/components/BlockTopMessage.vue'

export default defineComponent({
  name: 'BlockTopMessageCommon',
  components: {
    BlockTopMessage,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonUrl: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
  },
  setup() {
    const isVisible = ref(true)
    const onClose = () => {
      isVisible.value = false
    }
    return {
      isVisible,
      onClose,
    }
  },
})
